<template>
  <div>
    <navigationBar :fill="true"  />
    <div class="width-1200">
      <breadcrumb />
      <div class="nav-warrp">
        <div
          class="nav-item"
          :class="{ 'is-active': type === 0 }"
          @click="evt_select(0)"
        >
          <span class="bold">域名注册</span>
        </div>
        <div
          class="nav-item"
          :class="{ 'is-active': type === 1 }"
          @click="evt_select(1)"
        >
          <span class="bold">续费价格</span>
        </div>
        <div
          class="nav-item"
          :class="{ 'is-active': type === 2 }"
          @click="evt_select(2)"
        >
          <span class="bold">转入价格</span>
        </div>
      </div>
      <div class="price-current">
        <span class="label">当前显示</span>
        <span class="name">{{ priceTypes[type].name }}</span>
        <span class="desc">{{ priceTypes[type].desc }}</span>
      </div>
      <div style="margin-top:20px;" :class="{ 'fade-in': animating }">
        <Table
          class="bg-color-242631 bg-table-title"
          :loading="loading"
          :columns="columns"
          :data="list"
        >
        </Table>
      </div>
      <footBar />
    </div>
  </div>
</template>
<script>
import navigationBar from "components/navigationBar.vue";
import { getPriceList } from "api/domain.js";
import footBar from "components/footBar.vue";
import breadcrumb from "components/breadcrumb.vue";
export default {
  name: "price",
  components: {
    navigationBar,
    footBar,
    breadcrumb
  },
  data() {
    return {
      columns: [
        {
          width: 600,
          title: "域名后缀",
          key: "name",
          align: "center",
          render: (h, { row }) => {
            return h(
              "div",
              {
                style: {
                  paddingLeft: "40px",
                  textAlign: "left",
                  display: "flex",
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      marginRight: "40px",
                      textDecoration: "underline",
                      flex: "0 0 100px",
                    },
                  },
                  row.houzhui
                ),
                h(
                  "span",
                  {
                    style: {
                      flex: "1",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      "-webkit-line-clamp": 1,
                      "-webkit-box-orient": "vertical",
                    },
                  },
                  row.desc
                ),
              ]
            );
          },
        },
        {
          key: "levelName0",
          align: "center",
          renderHeader: (h) => {
            return h("span", "普通会员");
          },
          render: (h, { row }) => {
            if (
              row.priceList != null &&
              row.priceList[0].activityPrice === row.priceList[0].price
            ) {
              return h("span", `${row.priceList[0].activityPrice + '/年' || "-"}`);
            } else if (
              row.priceList != null &&
              row.priceList[0].activityPrice == null
            ) {
              return h("span", `${row.priceList[0].price + '/年'}`);
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    textDecoration: "line-through",
                    color: "#666",
                  },
                },
                row.priceList != null ? row.priceList[0].price + '/年' : ""
              ),
              h(
                "span",
                {
                  style: {
                    marginLeft: "10px",
                    color: "#999",
                  },
                },
                row.priceList != null
                  ? row.priceList[0].activityPrice + '/年' || ""
                  : ""
              ),
            ]);
          },
        },
        {
          key: "levelName1",
          align: "center",
          renderHeader: (h) => {
            return h("span", "金牌会员");
          },
          render: (h, { row }) => {
            if (
              row.priceList != null &&
              row.priceList[1].activityPrice === row.priceList[1].price
            ) {
              return h("span", `${row.priceList[1].activityPrice + '/年' || "-"}`);
            } else if (
              row.priceList != null &&
              row.priceList[1].activityPrice == null
            ) {
              return h("span", `${row.priceList[1].price + '/年'}`);
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    textDecoration: "line-through",
                    color: "#666",
                  },
                },
                row.priceList != null ? row.priceList[1].price + '/年' : ""
              ),
              h(
                "span",
                {
                  style: {
                    marginLeft: "10px",
                    color: "#999",
                  },
                },
                row.priceList != null
                  ? row.priceList[1].activityPrice + '/年' || ""
                  : ""
              ),
            ]);
          },
        },
        {
          key: "levelName2",
          align: "center",
          renderHeader: (h) => {
            return h("span", "钻石会员");
          },
          render: (h, { row }) => {
            if (
              row.priceList != null &&
              row.priceList[2].activityPrice === row.priceList[2].price
            ) {
              return h("span", `${row.priceList[2].activityPrice + '/年' || "-"}`);
            } else if (
              row.priceList != null &&
              row.priceList[2].activityPrice == null
            ) {
              return h("span", `${row.priceList[2].price + '/年'}`);
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    textDecoration: "line-through",
                    color: "#666",
                  },
                },
                row.priceList != null ? row.priceList[2].price + '/年' : ""
              ),
              h(
                "span",
                {
                  style: {
                    marginLeft: "10px",
                    color: "#999",
                  },
                },
                row.priceList != null
                  ? row.priceList[2].activityPrice + '/年' || ""
                  : ""
              ),
            ]);
          },
        },
        {
          key: "levelName3",
          align: "center",
          renderHeader: (h) => {
            return h("span", "皇冠会员");
          },
          render: (h, { row }) => {
            if (
              row.priceList != null &&
              row.priceList[3].activityPrice === row.priceList[3].price
            ) {
              return h("span", `${row.priceList[3].activityPrice + '/年' || "-"}`);
            } else if (
              row.priceList != null &&
              row.priceList[3].activityPrice == null
            ) {
              return h("span", `${row.priceList[3].price + '/年'}`);
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    textDecoration: "line-through",
                    color: "#666",
                  },
                },
                row.priceList != null ? row.priceList[3].price + '/年' : ""
              ),
              h(
                "span",
                {
                  style: {
                    marginLeft: "10px",
                    color: "#999",
                  },
                },
                row.priceList != null
                  ? row.priceList[3].activityPrice + '/年' || ""
                  : ""
              ),
            ]);
          },
        },
      ],
      list: [],
      type: 0,
      loading: false,
      animating: false,
      priceTypes: [
        { name: "域名注册", desc: "首年注册价格" },
        { name: "续费价格", desc: "单年续费价格" },
        { name: "转入价格", desc: "含一年续费价格（含续费一年）" },
      ],
    };
  },
  watch: {
    list() {
      this.animating = true;
      clearTimeout(this._animTimer);
      this._animTimer = setTimeout(() => {
        this.animating = false;
      }, 400);
    },
  },
  created() {
    this.req_getPriceList();
  },
  methods: {
    async req_getPriceList() {
      this.loading = true;
      try {
        const {code, data} = await getPriceList(this.type);
        this.loading = false;
        if(code === 200){
          this.list = data;
        }
      } catch (error) {
        this.loading = false;
      }
    },
    evt_select(type) {
      if (this.type === type) return;
      this.type = type;
      this.req_getPriceList();
    },
  },
};
</script>
<style lang="less" scoped>
.nav-warrp{
  display: flex;
  align-items: flex-end;
  margin: 80px 0 24px;
  .nav-item{
    flex: 1;
    height: 88px;
    line-height: 88px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    cursor: pointer;
    position: relative;
    transition: opacity .25s, transform .25s, box-shadow .25s,
      background-color .25s, color .25s;
    // 未选中：保留品牌色识别度，只做轻度退后（不做灰化，红紫色会显脏）
    opacity: .62;
    &:hover{
      opacity: .9;
    }
    .bold{
      font-weight: bold;
      font-size: 24px;
      transition: font-size .25s;
    }
     &:first-child {
      // 白底项在浅灰页面上不可见，未选中时改浅灰底 + 灰字
      background-color: #F2F5F9;
      border-top-left-radius: 15px;
      border-bottom-left-radius: 15px;
      color: #666666;
      &::after{
        content: "首年注册";
        font-size: 16px;
        line-height: 78px;
        margin-left: 10px;
      }
    }
    &:nth-child(2) {
      background-color: #EB6D6D;
      color: #fff;
      &::after{
        content: "单年续费价格";
        font-size: 16px;
        line-height: 78px;
        margin-left: 10px;
      }

    }
    &:nth-child(3) {
      background-color: #8F6DEB;
      border-top-right-radius: 15px;
      border-bottom-right-radius: 15px;
      color: #fff;
      &::after{
        content: "含一年续费价格";
        font-size: 16px;
        line-height: 78px;
        margin-left: 10px;
      }
    }
    // 选中态：满色 + 轻微上移 + 柔和投影 + 底部居中指示条
    &.is-active{
      opacity: 1;
      transform: translateY(-4px);
      box-shadow: 0 8px 16px rgba(31, 45, 61, .16);
      .bold{
        font-size: 26px;
      }
      &::before{
        content: "";
        position: absolute;
        left: 50%;
        bottom: -4px;
        transform: translateX(-50%);
        width: 48px;
        height: 3px;
        border-radius: 2px;
        background-color: #fff;
      }
    }
    &:first-child.is-active{
      background-color: #fff;
      color: #c4332e;
      border: 1px solid #E9E9E9;
      border-bottom: none;
      &::before{
        background-color: #c4332e;
      }
    }
  }
}
// 当前价格类型提示条：一眼看清现在显示的是哪一类价格
.price-current{
  display: flex;
  align-items: center;
  padding: 12px 20px;
  margin-bottom: 20px;
  background-color: #F2F7FE;
  border-left: 4px solid @brand;
  border-radius: 4px;
  font-size: 14px;
  color: @text-body;
  .label{
    font-weight: bold;
    color: @text-title;
    margin-right: 12px;
  }
  .name{
    font-size: 16px;
    font-weight: bold;
    color: @brand;
    margin-right: 8px;
  }
  .desc{
    color: @text-body;
  }
}
// 切换价格类型时表格淡入，强化「当前显示的是哪一类价格」
.fade-in{
  animation: price-fade-in .3s ease;
}
@keyframes price-fade-in{
  from{
    opacity: .3;
  }
  to{
    opacity: 1;
  }
}
</style>
